<template>
  <div>
    <!-- Edit Payment Methods -->
    <template v-if="editPaymentMethods">
      <credit-card class='stripe-card' v-on:changeView="editPaymentMethods = $event"></credit-card>
      <div class="outline w3-margin-top w3-white" v-for="(item, key, i) in state.user.stripeData.sources.data" :key="i">
        <template v-if="item.last4">
          <header class="w3-row outline">
            <img src="../assets/cards/visa.png" v-if="item.brand === 'Visa'" />
            <img src="../assets/cards/mastercard.png" v-if="item.brand === 'MasterCard'" />
            <img src="../assets/cards/amex.png" v-if="item.brand === 'American Express'" />
            <img src="../assets/cards/discover.png" v-if="item.brand === 'Discover'" />
            <img src="../assets/cards/unknown.png" v-if="item.brand === 'Unknown'" />

            <div class="w3-right" style="font-size:12px;">
              <button class="w3-button w3-green rightButton" v-if="item.id === state.user.stripeData.default_source">DEFAULT</button>
              <button @click.prevent="setDefaultCard(item.id)" class="w3-button dark rightButton" v-if="!(item.id === state.user.stripeData.default_source)">SET DEFAULT</button>
              <button @click.prevent="removeCard(item.id)" class="w3-button w3-red" style="padding:6px 10px;"><i class="fas fa-trash"></i></button>
            </div>
          </header>
          <div class="w3-row w3-margin-bottom w3-center" style="font-family:'Open Sans'">
            <div style="margin:25px auto 15px;">
              <span style="font-size:24px; font-weight:300;">xxxx xxxx xxxx </span><span style="font-size:20px; font-weight:500;">{{item.last4}}</span>
            </div>
            <div class="w3-padding w3-left">
              <span style="font-size:7px; float:left; margin-top:2px;">ZIP<br/>CODE</span>
              <span style="padding-left:10px;">{{item.address_zip}}</span>
            </div>
            <div class="w3-padding w3-right">
              <span style="font-size:7px; float:left; margin-top:2px;">VALID<br/>THRU</span>
              <span style="padding-left:10px;">{{item.exp_month}} / {{item.exp_year}}</span>
            </div>
          </div>
        </template>
      </div>
      <button class="w3-button w3-block w3-red w3-margin-top" @click="editPaymentMethods = false">Exit Payment Methods</button>
    </template>
    <!-- Default Payment Methods -->
    <template v-if="!editPaymentMethods">
      <template v-if="state.user.stripeData.sources.data.length > 0">
        <div class="outline cardbg" v-for="(item, key, i) in state.user.stripeData.sources.data" :key="i">
          <template v-if="item.id === state.user.stripeData.default_source">
            <header class="w3-row outline">
              <img src="../assets/cards/visa.png" v-if="item.brand === 'Visa'" />
              <img src="../assets/cards/mastercard.png" v-if="item.brand === 'MasterCard'" />
              <img src="../assets/cards/amex.png" v-if="item.brand === 'American Express'" />
              <img src="../assets/cards/discover.png" v-if="item.brand === 'Discover'" />
              <img src="../assets/cards/unknown.png" v-if="item.brand === 'Unknown'" />
              <div class="w3-right" style="font-size:12px;">
                <button class="w3-button rightButton" v-if="item.id === state.user.stripeData.default_source">DEFAULT</button>
              </div>
            </header>
            <div class="w3-row w3-margin-bottom w3-center" style="font-family:'Open Sans'">
              <div style="margin:25px auto 15px;">
                <!-- <span style="font-size:24px; font-weight:300;">{{state.user.displayName}}</span><br/> -->
                <span style="font-size:20px; font-weight:300;">xxxx xxxx xxxx </span><span style="font-size:20px; font-weight:500;">{{item.last4}}</span>
              </div>
              <div class="w3-padding w3-left">
                <span style="font-size:7px; float:left; margin-top:2px;">ZIP<br/>CODE</span>
                <span style="padding-left:10px;">{{item.address_zip}}</span>
              </div>
              <div class="w3-padding w3-right">
                <span style="font-size:7px; float:left; margin-top:2px;">VALID<br/>THRU</span>
                <span style="padding-left:10px;">{{item.exp_month}} / {{item.exp_year}}</span>
              </div>
            </div>
          </template>
        </div>
        <button class="w3-button w3-block dark" @click="editPaymentMethods = true">Manage Payment Methods</button>
      </template>
      <template v-else>
        <div class="outline">
          <header class="light outline">
            <h5 class="comfortaa">Payment Methods</h5>
            <p>View or Update</p>
          </header>
          <div class="w3-row w3-margin-bottom">
            <div class="w3-container w3-white">
              <p style="margin-top:15px;">
                <template v-if="!cartView">
                  No Payment Methods yet
                </template>
                <template v-if="cartView">
                  Add a Payment Method to Checkout
                </template>
              </p>
            </div>
          </div>
        </div>
        <button class="w3-button w3-block w3-green" @click="editPaymentMethods = true">Add Payment Method</button>
      </template>
    </template>
  </div>
</template>

<script>
import creditCard from '@/components/creditCard'
var dataStore = require('../dataStore').default

export default {
  name: 'paymentMethods',
  props: {
    cartView: false
  },
  data () {
    return {
      state: dataStore.state,
      editPaymentMethods: false
    }
  },
  components: {creditCard},
  methods: {
    setDefaultCard(id) {
      dataStore.updateStripeDefaultSource(id)
    },
    removeCard(id) {
      dataStore.removeCard(id)
    }
  }
}
</script>

<style scoped>
  .rightButton {padding:6px 10px;}
  .invoiceRow {cursor:pointer;}
  .cardbg {background: #fff; margin-bottom: 8px;}
  .cardbg:last-child {margin-bottom: 0;}
  .ElementsApp, .ElementsApp .InputElement {color:#000;}
</style>



// WEBPACK FOOTER //
// src/components/paymentMethods.vue